import { ActionTypes } from "../constants/action-types";
const initialState = {
};

export function subscriptionReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ActionTypes.SET_SUBSCRIPTION:
            return { ...state, ...payload };
        default:
            return state;
    }
}
